import { Paper, CircularProgress, Box } from "@mui/material";
import MonthlySummaryTable from "./MonthlySummaryTable";
import MonthlySummaryFilter from "./MonthlySummaryFilter/MonthlySummaryFilter";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { setDisplayErrorSnackBar, setUserToken } from '../../../../../../features/userSlice';
import { forecastersEndPointLogic } from '../../../../../../logic/AssetManagement/Forecasters/forecastersEndPointLogic';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import store from '../../../../../../store';

const tableheaders = {
  Metric: "Period",
  Predicted: "Forecast",
  Actual: "Actual",
  Deviation: "Deviation",
};

const MonthlySummary = () => {
  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const selectedMonth = searchParams.get("selectedMonth") as any;
  const selectedSite: any = searchParams.get("selectedSite");
  const contentSharedUid:any = searchParams.get("contentSharedUid");
  const pastMonthForcast = useSelector((state: any) => state.forecasters?.pastMonthForcast);
  const [selectedFilter, setSelectedFilter] = useState<string>("Key Metrics");
  const QUERY_ID = "5671636300726272";
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchPastMonthForcast = async () => {
      if (contentSharedUid) {
        try {
          setLoading(true);
          await forecastersEndPointLogic.getPastMonthForcast(oauthTokenHeader, QUERY_ID, selectedSite, selectedMonth, contentSharedUid, dispatch);
        } catch (error: any) {
          store.dispatch(setDisplayErrorSnackBar({ message: error.message, severity: "error" }));
        } finally {
          setLoading(false);
        }
      }
    };
    if (contentSharedUid) {
      fetchPastMonthForcast();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentSharedUid, selectedMonth, selectedSite, dispatch]);

  // Transform pastMonthForcast?.query_output to match the rows structure
  const transformedRows = pastMonthForcast?.query_output.map((item: any) => ({
    Metric: item.Metric,
    Predicted: item.forecast,
    Actual: item.Actual,
    Deviation: item.Deviation
  })) || [];

  useEffect(() => {
    const newSearchParams = new URLSearchParams(location.search);
    if (location.pathname === "/assets/overview/forecaster/forecasterInfo/MonthlySummery" && newSearchParams.get("page") !== "0") {
      newSearchParams.set("page", "0");
      navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  return (
    <>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <CircularProgress color="secondary" />
        </Box>
      ) : (
        <Paper sx={{ padding: "8px 16px" }}>
          <MonthlySummaryFilter setSelectedFilter={setSelectedFilter} />
          <MonthlySummaryTable tableHeadings={tableheaders} rows={transformedRows} selectedFilter={selectedFilter} />
        </Paper>
      )}
    </>
  )
}

export default MonthlySummary;
